// eslint-disable-next-line import/prefer-default-export
export const defaultRequestConfig = {
  // os
  osHost: "os-stable",
  osEnv: "",
  osSuffix: ".yishou.com",
  // erp
  erpHost: "erp-stable",
  erpEnv: "",
  erpSuffix: ".yishou.com",
  // 微服务
  gatewayHost: "gateway-dev",
  gatewayEnv: "3",
  gatewaySuffix: ".yishou.com",
  // api
  apiHost: "api-stable",
  apiEnv: "",
  apiSuffix: ".yishou.com",
  // osweb
  oswebHost: "osweb-stable",
  oswebEnv: "",
  oswebSuffix: ".yishou.com",
};

export const defaultProdRequestConfig = {
  // os
  osHost: "os-stable",
  osEnv: "",
  osSuffix: ".yishouapp.com",
  // erp
  erpHost: "erp-stable",
  erpEnv: "",
  erpSuffix: ".yishouapp.com",
  // 微服务
  gatewayHost: "gateway-dev",
  gatewayEnv: "3",
  gatewaySuffix: ".yishouapp.com",
  // api
  apiHost: "api-stable",
  apiEnv: "",
  apiSuffix: ".yishouapp.com",
  // osweb
  oswebHost: "osweb-stable",
  oswebEnv: "",
  oswebSuffix: ".yishouapp.com",
};



// WEBPACK FOOTER //
// ./src/const/env.js